module.exports = __webpack_public_path__ + "img/mastercard.aee5f7b1465a5f4404202cde6e3ca2bb.svg";